// Centralized navigation configuration for Rozier Concept.
// Used by Header mega-menu, hub pages and sub-page placeholders.

export const NAV_SECTIONS = [
  {
    key: "bati",
    label: "Le Bâti",
    path: "/le-bati",
    intro: "Construire durablement, rénover intelligemment, penser le bâti autrement.",
    image: "/images/bati.jpg",
    items: [
      {
        key: "charpente-zinguerie",
        label: "Charpente et zinguerie",
        path: "/le-bati/charpente-zinguerie",
        teaser: "Structures bois, couvertures, finitions zinc et étanchéité durable."
      },
      {
        key: "menuiseries",
        label: "Menuiseries",
        path: "/le-bati/menuiseries",
        teaser: "Menuiseries extérieures et intérieures, sur mesure, performantes."
      },
      {
        key: "isolation",
        label: "Isolation extérieure et combles",
        path: "/le-bati/isolation-exterieure-et-combles",
        teaser: "Isolation biosourcée, ITE tous supports, confort thermique."
      },
      {
        key: "ossature-bois",
        label: "Ossature bois",
        path: "/le-bati/ossature-bois",
        teaser: "Constructions neuves, extensions, carports, pergolas, tiny house."
      },
      {
        key: "renovation-energetique",
        label: "Rénovation énergétique",
        path: "/le-bati/renovation-energetique",
        teaser: "Stratégie bioclimatique globale, du gros œuvre au confort fin."
      }
    ]
  },
  {
    key: "paysage",
    label: "Le Paysage",
    path: "/le-paysage",
    intro: "Une lecture sensible du lieu avant le moindre tracé.",
    image: "/images/paysage.jpg",
    items: [
      {
        key: "conception",
        label: "Conception 2D / 3D",
        path: "/le-paysage/conception-2d-3d",
        teaser: "Plans d'implantation, croquis d'ambiance, modélisations réalistes."
      },
      {
        key: "structuration",
        label: "Structuration des espaces",
        path: "/le-paysage/structuration-des-espaces",
        teaser: "Tracés régulateurs, nombre d'or, harmonie naturelle du lieu."
      },
      {
        key: "cours-chemins",
        label: "Cours et chemins",
        path: "/le-paysage/cours-et-chemins",
        teaser: "Allées, dallages, pavages, circulations fluides et matières nobles."
      },
      {
        key: "amenagements-paysagers",
        label: "Aménagements paysagers",
        path: "/le-paysage/amenagements-paysagers",
        teaser: "Végétal, lumière, ambiances. Un jardin qui a du sens."
      },
      {
        key: "amenagements-exterieurs",
        label: "Aménagements extérieurs",
        path: "/le-paysage/amenagements-exterieurs",
        teaser: "Clôtures, portails, murets, terrasses, plages de piscine, pergolas."
      },
      {
        key: "jardins",
        label: "Jardins",
        path: "/le-paysage/jardins",
        teaser: "Jardins d'énergie, jardins de contemplation, jardins de vie."
      }
    ]
  },
  {
    key: "energetique",
    label: "L'Énergétique",
    path: "/l-energetique",
    intro: "Votre lieu vous parle. Nous l'écoutons avant de le dessiner.",
    image: "/images/energetique.jpg",
    items: [
      {
        key: "geobiologie",
        label: "Géobiologie",
        path: "/l-energetique/geobiologie",
        teaser: "Diagnostic des zones perturbées sous et autour du bâti."
      },
      {
        key: "feng-shui-paysage",
        label: "Feng shui paysage",
        path: "/l-energetique/feng-shui-paysage",
        teaser: "Orientation, flux, implantation. Le paysage en cohérence."
      },
      {
        key: "feng-shui-habitat",
        label: "Feng shui de l'habitat",
        path: "/l-energetique/feng-shui-de-l-habitat",
        teaser: "Structure, ouvertures, matières. L'habitat en équilibre."
      },
      {
        key: "feng-shui-business",
        label: "Feng shui du business",
        path: "/l-energetique/feng-shui-du-business",
        teaser: "Espaces de travail, commerces, lieux de prospérité durable."
      },
      {
        key: "dragon-eau",
        label: "Le dragon d'eau",
        path: "/l-energetique/le-dragon-d-eau",
        teaser: "Outil ancestral pour activer les flux de prospérité du lieu."
      }
    ]
  }
];

export const SIMPLE_LINKS = [
  { label: "Accueil", path: "/" },
  { label: "La Méthode Rozier", path: "/la-methode-rozier" }
];

export function findSectionAndItemByPath(pathname) {
  for (const section of NAV_SECTIONS) {
    if (section.path === pathname) return { section, item: null };
    const item = section.items.find((i) => i.path === pathname);
    if (item) return { section, item };
  }
  return { section: null, item: null };
}
